module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_wrap unit"
  }, [_c('NavTab'), _vm._v(" "), _c('div', {
    staticClass: "search-box "
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('div', {
    staticClass: "group situation margin-right-15 searchArrow"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("所属单位")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.model.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.model, "organizationId", $$v)
      },
      expression: "model.organizationId"
    }
  }, _vm._l((_vm.organizationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.simpName,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.realname),
      expression: "model.realname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.model.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "realname", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.username),
      expression: "model.username",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入登录账号"
    },
    domProps: {
      "value": (_vm.model.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "username", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.phone),
      expression: "model.phone",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.model.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("警员号")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.policeNo),
      expression: "model.policeNo",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入警员号"
    },
    domProps: {
      "value": (_vm.model.policeNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "policeNo", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "select-wrap"
  }, [_c('div', {
    staticClass: "group btn-box"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newadd
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletes
    }
  }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detailShow),
      expression: "!detailShow"
    }],
    staticClass: "table_wrap"
  }, [_c('div', {
    staticClass: "table_layout"
  }, [_c('div', {
    staticClass: "table_scroll"
  }, [_c('el-table', {
    attrs: {
      "border": "",
      "data": _vm.dataList,
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.tableHeaderColor
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "1",
    attrs: {
      "min-width": "80",
      "align": "center",
      "label": "姓名",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.realname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "2",
    attrs: {
      "min-width": "100",
      "align": "center",
      "label": "登录账号",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.username))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "3",
    attrs: {
      "min-width": "130",
      "align": "center",
      "label": "身份证号",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.identityCardNo))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "4",
    attrs: {
      "min-width": "100",
      "align": "center",
      "label": "手机号",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "6",
    attrs: {
      "min-width": "160",
      "align": "center",
      "label": "小程序用户编号",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.miniOpenId))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "7",
    attrs: {
      "align": "center",
      "label": "认证状态",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.miniOpenId == null ? "未实名认证" : "已实名认证"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "8",
    attrs: {
      "align": "center",
      "label": "岗位角色",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.roleNames))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "9",
    attrs: {
      "min-width": "100",
      "align": "center",
      "label": "操作",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "primary pointer mr15",
          attrs: {
            "val": _vm.val
          },
          on: {
            "click": function($event) {
              return _vm.alter(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('span', {
          staticClass: "primary pointer",
          on: {
            "click": function($event) {
              return _vm.deletes(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (!_vm.dataList.length) ? _c('div', [_c('nt-no-data')], 1) : _vm._e(), _vm._v(" "), (_vm.dataList.length) ? _c('div', {
    staticClass: "pagination"
  }, [_c('nt-pagination', {
    ref: "child",
    on: {
      "fetchData": _vm.fetchData
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.detailShow) ? _c('detail', {
    attrs: {
      "val": _vm.val
    },
    on: {
      "func": _vm.getRoleSon,
      "fetchData": _vm.fetchData
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58901a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/staffManagement/list.vue
// module id = TVbO
// module chunks = 6